module.exports = __webpack_public_path__ + "img/produktbroschuren_ch.a9bd68e3.png";